import { ApolloError } from '@apollo/client';

import { getServerErrorMessage } from 'lib/apollo.utils';
import { ERROR_MESSAGE_ASSIGNMENT_CLOSED } from 'global/constants';

export function isStudentClosedAssignmentError(error: ApolloError) {
  const errorMessage = getServerErrorMessage(error) || (error && error.message);
  return (
    !!errorMessage && errorMessage.includes(ERROR_MESSAGE_ASSIGNMENT_CLOSED)
  );
}
